export default {
  welcome: 'Willkommen',
  beeText1: 'Bzz... Möchtest du, dass ich dir helfe, einige Aufgaben zu erstellen?',
  beeText2: 'Schau dir das Textfeld unten an. Es gibt dir einen Hinweis, wie du anfangen kannst',
  beeText3:
    'Bzzz... Ich bin eine fleißige Biene, aber ich kann dir helfen, einige Aufgaben zu erstellen',
  task: 'Aufgabe',
  taskExample1: 'Das Badezimmer putzen',
  taskExample2: 'Mahlzeiten vorbereiten',
  taskExample3: 'Einkauf im Supermarkt',
  taskExample4: 'Wäsche waschen',
}
